<div class="graph-container">
    <div class="header">
        <span>{{ 'HEADBAND.MODELE.MODAL.DATA.TITLE' | translate }}</span>
    </div>
    <div #mapElement class="map-modele-container"></div>
    <div id="map" class="map">
        <div id="info"></div>
    </div>
</div>
